import SoftTypography from "components/SoftTypography";

const datosEmpresa = () => {
  return (
    <>
      <SoftTypography variant="h5" fontWeight="medium">
        ARAB
      </SoftTypography>
    </>
  );
};

export default datosEmpresa;
